import { api } from './axios'
import type { RegistrarCaptadorForm } from '@/types'

export async function registrarCaptador(dto: RegistrarCaptadorForm) {
  const response = await api.post<{ id: number; usuarioId: number }>('/parceiros/captadores', dto)
  return response.data
}
